import { Button, CircularProgress } from '@mui/material';

export const LoadMoreButton = ({
    onClick,
    loading = false,
    disabled = false,
    children,
    variant = 'contained',
    ...props
}: {
    onClick: () => void;
    loading?: boolean;
    disabled?: boolean;
    children: React.ReactNode;
    variant?: 'contained' | 'text' | 'outlined';
}) => {
    return (
        <Button
            variant={variant}
            onClick={onClick}
            disabled={disabled || loading}
            sx={{ marginTop: 3, alignSelf: 'baseline' }}
            {...props}
        >
            {loading && <CircularProgress size={16} sx={{ marginRight: 1 }} />}
            {children}
        </Button>
    );
};
